import { type FetchNftMyCollectiblesV2Params, type NFTFormattedCollectibleDTO } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchMyNfts } from '../api';

export type UseMyNftsQueryOptions = Omit<
	UseQueryOptions<Array<NFTFormattedCollectibleDTO>, unknown, Array<NFTFormattedCollectibleDTO> | undefined>,
	'queryFn' | 'queryKey' | 'select'
>;

export const useMyNftsQuery = <TData = Array<NFTFormattedCollectibleDTO> | undefined>(
	select: (data: Array<NFTFormattedCollectibleDTO> | undefined) => TData,
	params?: FetchNftMyCollectiblesV2Params & { walletCustody: string },
	options?: UseMyNftsQueryOptions
) =>
	useQuery({
		enabled: !!params?.walletCustody,
		queryFn: () => fetchMyNfts(params),
		queryKey: ['myNfts', params],
		select,
		...options
	});
